import { Card, CardHeader, CardBody, Chip, Skeleton, Tooltip } from "@heroui/react";
import { ThemedText } from "@/components/ui";
import { formatThousands } from "@/utils";
import { LuTriangleAlert, LuInfo } from "react-icons/lu";

const SkeletonRow = () => (
    <div className="flex items-center justify-between py-2.5">
        <Skeleton className="h-4 w-36 rounded-md" />
        <Skeleton className="h-5 w-16 rounded-md" />
    </div>
);

const LowStockCard = ({ stocks, isLoading }) => {
    return (
        <Card className="border border-default-200" shadow="none">
            <CardHeader className="flex flex-row items-center justify-between px-4 pb-0 pt-4">
                <div className="flex items-center gap-1.5">
                    <Tooltip
                        content="Produk dengan stok tersedia ≤ 25 unit, diurutkan dari yang paling sedikit"
                        placement="right"
                    >
                        <span className="cursor-help text-default-400">
                            <LuInfo size={12} />
                        </span>
                    </Tooltip>
                    <ThemedText size="md" className="font-semibold">
                        Stok Menipis
                    </ThemedText>
                </div>
                <ThemedText variant="secondary" size="xs">
                    &le; 25 unit
                </ThemedText>
            </CardHeader>
            <CardBody className="px-4 pb-4 pt-2">
                <div className="divide-y divide-default-100">
                    {isLoading ? (
                        Array.from({ length: 5 }).map((_, i) => (
                            <SkeletonRow key={i} />
                        ))
                    ) : stocks?.length > 0 ? (
                        stocks.map((item, index) => (
                            <div
                                key={`${item.material_id}-${index}`}
                                className="flex items-center justify-between py-2.5"
                            >
                                <ThemedText size="sm">
                                    {item.material_name}
                                </ThemedText>
                                <Chip
                                    size="sm"
                                    variant="flat"
                                    color={
                                        item.available <= 0
                                            ? "danger"
                                            : "warning"
                                    }
                                    startContent={
                                        item.available <= 0 ? (
                                            <LuTriangleAlert size={12} />
                                        ) : null
                                    }
                                >
                                    {item.available <= 0
                                        ? "Habis"
                                        : `${formatThousands(item.available)} ${item.unit_name}`}
                                </Chip>
                            </div>
                        ))
                    ) : (
                        <div className="py-8 text-center">
                            <ThemedText variant="success" size="sm">
                                Semua stok aman.
                            </ThemedText>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default LowStockCard;
